import ctmLogo from './assets/ctm-logo.svg';

const LogoFull = () => {
  return (
    <img
      src={ctmLogo}
      alt="CTM"
      width={89}
      height={30}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default LogoFull;
